// Environment-gated logger — the ONLY place the app may write to the console.
// In production builds every level is a no-op (no performance cost, no information
// leakage); in development the messages are forwarded to the matching console method.
// Never pass tokens, cookies, passwords or Authorization headers to these helpers.
const ENABLED = process.env.NODE_ENV !== 'production';

const make = (method) => (ENABLED
  ? (...args) => { console[method](...args); }
  : () => {});

export const logger = {
  debug: make('debug'),
  info: make('info'),
  warn: make('warn'),
  error: make('error'),
};

export default logger;
